import getMatchedStringArray from './getMatchedStringArray.mjs';

const extractPathParamStringsFromPathname = (rawPathname) => {
  const regex = /\[(.*?)]/gi;
  return getMatchedStringArray(rawPathname, regex);
};
const divideQueryParams = (originalQuery, pathParamStrings) => {
  const pathParams = {};
  const queryParams = {};
  const queryArray = Object.entries(originalQuery);
  for (const oneOfQuery of queryArray) {
    const key = oneOfQuery[0];
    const value = oneOfQuery[1];
    if (pathParamStrings.includes(key)) {
      pathParams[key] = value;
    } else {
      queryParams[key] = value;
    }
  }
  return { pathParams, queryParams };
};
const getQueryFromSearchParams = (searchParams) => {
  const queryParams = {};
  searchParams.forEach((value, name) => {
    if (queryParams[name] !== void 0) {
      const previousValue = queryParams[name];
      queryParams[name] = Array.isArray(previousValue) ? [...previousValue, value] : [previousValue, value];
    } else {
      queryParams[name] = value;
    }
  });
  return queryParams;
};
const convertFalsyQuery = (queryParams) => {
  const filteredQueryParams = {};
  Object.keys(queryParams).forEach((key) => {
    const queryParam = queryParams[key];
    filteredQueryParams[key] = queryParam ?? "";
  });
  return filteredQueryParams;
};

export { convertFalsyQuery, divideQueryParams, extractPathParamStringsFromPathname, getQueryFromSearchParams };
//# sourceMappingURL=params.mjs.map
